import restfulBase from '@/services/negotiations/core/base';

export const negotiationsService = (companyId: string) =>
  restfulBase(`companies/${companyId}/negotiations`);

export default negotiationsService;
